import React from 'react'
import Scroll from './Scroll'
import { OutboundLink } from 'gatsby-plugin-google-gtag'

type Props = { message: string }

const Header: React.FC<Props> = ({ message }) => {
  return (
    <section id="header">
      <header className="major">
        <h1>たんぽぽ絵日記</h1>
        <p>{message}</p>
        <p>
          <OutboundLink href="https://tampopo-diary.booth.pm/items/2816079">
            BOOTHにて販売中！
            <br />
            1st album 「はじまりの色」
          </OutboundLink>
        </p>
      </header>
      <div className="container">
        <ul className="actions special">
          <li>
            <Scroll type="id" element="top">
              <a href="#top" className="button primary fit-width">
                Profile
              </a>
            </Scroll>
          </li>
        </ul>
      </div>
    </section>
  )
}

export default Header
